<template>
    <kl-ol-map-tools-bar mod-horizontal>
        <kl-ol-map-tools-action-group mod-horizontal v-if="showDelete">
            <kl-ol-map-tools-action
                @click.prevent="onDelete"
                v-vl-tooltip.bottom.hide-immediately="'Zone&nbsp;wissen'"
                icon="bin"
                mod-error
                :mod-disabled="disableDelete"
            />
        </kl-ol-map-tools-action-group>
        <kl-ol-map-tools-action-group mod-horizontal v-if="showImport">
            <kl-ol-map-tools-action
                @click.prevent="onImport"
                v-vl-tooltip.bottom.hide-immediately="'Zone&nbsp;importeren'"
                icon="file-upload"
            />
        </kl-ol-map-tools-action-group>
    </kl-ol-map-tools-bar>
</template>

<script lang="ts">
import {defineComponent, ref} from 'vue';

export default defineComponent({
    name: 'KlDrawZoneActions',
    emits: ['delete', 'import'],
    props: {
        showDelete: { type: Boolean, default: false },
        showImport: { type: Boolean, default: false },
        disableDelete: { type: Boolean, default: false },
    },
    setup(props, {emit}) {
        return {
            onDelete: () => emit('delete'),
            onImport: () => emit('import'),
        }
    }
})
</script>

<style scoped lang="scss">
</style>
